import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { GQLFont, GQLSide, GQLTextEngraving } from '@jewelutions/core-crm-server-api-client-domain';
import { Box } from '../../types-hack';
interface IProps {
  side: GQLSide;
  engraving: GQLTextEngraving;
  font: GQLFont;
}

const EngravingSingleLetterDetails: React.FC<IProps> = ({ side, engraving, font }: IProps) => {
  return (
    <Card style={{ width: 'fit-content' }}>
      <Box p={5}>
        <Typography component="span" variant={'h6'}>
          Single letter engraving : {engraving.text![0]}
        </Typography>
        <Typography component="span" variant={'h6'}>
          Text font family : {font.name} & Text font size :
          {engraving.fontSize !== -1 ? engraving.fontSize : 'MAX'}
        </Typography>
        <Typography component="span" variant={'h6'}>
          Side : {side}
        </Typography>
      </Box>
    </Card>
  );
};

export default EngravingSingleLetterDetails;
